import type { TiptapState } from '@/types';

import Serializer from '../../Serializer';
import { PostHeading } from '../heading';
import { listContainer } from './TableOfContents.css';
import type { TPostTableOfContentsProps } from './TableOfContents.type';
import type { TocItem } from './types';

export { listContainer as postTableOfContentsListContainerClass } from './TableOfContents.css';

const renderList = (items: TocItem[], listType: 'unordered' | 'ordered'): TiptapState => {
  const listBlock = listType === 'unordered' ? 'bulletList' : 'orderedList';

  return {
    type: listBlock,
    attrs: { id: 'table-of-contents-list' },
    content: items.map((item) => renderListItem(item, listType)),
  };
};

const renderListItem = (item: TocItem, listType: 'unordered' | 'ordered'): TiptapState => {
  return {
    type: 'listItem',
    attrs: { id: item.id },
    content: [
      {
        type: 'paragraph',
        attrs: { textAlign: 'left' },
        content: [
          {
            type: 'text',
            text: item.title,
            marks: [{ type: 'link', attrs: { href: `#${item.id}`, target: '_self' } }],
          },
        ],
      },
      renderList(item.children, listType),
    ],
  };
};

export const PostTableOfContents = (props: TPostTableOfContentsProps) => {
  const { element } = props;
  const { title, listType, showTitle, data } = element.attrs;

  return (
    <>
      {showTitle ? (
        <PostHeading
          key={`table-of-contents-title-${title}`}
          element={{
            type: 'heading',
            attrs: { level: 2, id: 'table-of-contents-title' },
            content: [{ text: title || '', type: 'text' }],
          }}
        >
          {title}
        </PostHeading>
      ) : null}
      <div className={listContainer}>
        {data && data.length > 0 && (
          <Serializer content={renderList(data, listType ?? 'unordered')} upgradePath="/upgrade" />
        )}
      </div>
    </>
  );
};
